export const CAMPAIGN_STATUS_COLOR_CLASS = {
    DRAFT: "status-draft",
    CREATED: "bg-info",
    READY: "status-ready",
    PUBLISHING: "status-publishing",
    PUBLISHED: "status-published",
    IN_PROGRESS: "bg-primary",
    PAUSED: "status-paused",
    COMPLETED: "bg-success",
    PARTIAL_COMPLETED: "status-partial-completed",
    FAILED: "bg-danger",
    CANCELLED: "bg-secondary",
    EXPIRED: "status-expired",
};
